import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { DateAndTimeComponent } from '@features-shared/date-and-time/date-and-time.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateTimeInfo } from '@shared/types';
import { EllipsisTooltipComponent } from '../ellipsis-tooltip/ellipsis-tooltip.component';
import { InfoTooltipComponent } from '../info-tooltip/info-tooltip.component';
import { TextBlockComponent } from '../text-block/text-block.component';

@Component({
    selector: 'text-label',
    standalone: true,
    imports: [
        TranslateModule,
        EllipsisTooltipComponent,
        TextBlockComponent,
        DateAndTimeComponent,
        RouterLink,
        InfoTooltipComponent,
        NgTemplateOutlet,
    ],
    templateUrl: './text-label.component.html',
    styleUrl: './text-label.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextLabelComponent {
    private translate = inject(TranslateService);

    text = input<string | undefined | null>(undefined);
    label = input<string | undefined | null>(undefined);
    dateTime = input<DateTimeInfo | undefined | null>(undefined);
    showTime = input<boolean>(false);
    infoTooltipText = input<string>('');

    inline = input<boolean>(false);
    dashOnEmpty = input<boolean>(true);
    noMargin = input<boolean>(true);
    noLabelDots = input<boolean>(false);
    labelMinWidth = input<string | undefined>(undefined);
    size = input<'small' | 'large' | undefined>(undefined);

    redirectUrl = input<string | null>(null);
    routerLink = input<string | null>(null);
    routerQueryParams = input<Params | null>(null);

    innerHtml = input<boolean>(false);

    textBlock = input<boolean>(false);
    textBlockMaxHeight = input<string | undefined>(undefined);

    class = input<string | undefined>(undefined);

    computedText = computed(() => (this.text() ? this.text() || '' : this.dashOnEmpty() ? '-' : ''));
    computedLabel = computed(() =>
        this.noLabelDots()
            ? this.translate.instant(this.label() || ' ')
            : `${this.translate.instant(this.label() || ' ')}:`
    );
}
